export default __webpack_public_path__ + "static/media/concealed_green.175a8e13.png";